import { Entry } from '../Entry'

export function Entry20261021() {
  return (
    <Entry title="2026 Oct 21 - v3.11.22">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/27030/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
